export const debounce = <E extends Event>(func: (event: E) => void, wait: number): ((event: E) => void) => {
  let timeoutID: number | undefined

  return function (this: unknown, event: E): void {
    if (timeoutID !== undefined) {
      clearTimeout(timeoutID)
    }

    timeoutID = window.setTimeout(() => {
      func.call(this, event)
    }, wait)
  }
}
